// Module
var code = "<a class=\"product__image__zoom btn btn-icon-only default\" data-bind=\"click: $data.ShowOriginalImage.bind($data, $parent.Id, $parent.ImageTableType), preventBubble: ['click']\"> <i class=\"fa fa-search-plus\"></i> </a>";
// Exports
export default code;